import React from 'react';

const getHeight = (s, w, h) => (parseInt(s, 10) / w) * h + 'px';

export function Filter(props) {
  const fill = props.fill || 'black';
  const size = props.size || '24px';

  return (
    <svg width={size} height={getHeight(size, 13, 13)} viewBox="0 0 13 13">
      <path
        fill={fill}
        fillRule="evenodd"
        d="M3.783 10.696a.646.646 0 0 1-.653-.653c0-.365.287-.652.653-.652.365 0 .652.287.652.652a.646.646 0 0 1-.652.653m7.565-1.305H5.635a1.955 1.955 0 0 0-1.852-1.304c-.861 0-1.566.548-1.853 1.304H.652a.646.646 0 0 0-.652.652c0 .366.287.653.652.653H1.93c.261.756.992 1.304 1.853 1.304.86 0 1.565-.548 1.852-1.304h5.713a.646.646 0 0 0 .652-.653.646.646 0 0 0-.652-.652M7.565 6c0-.365.287-.652.652-.652.366 0 .653.287.653.652a.646.646 0 0 1-.653.652A.646.646 0 0 1 7.565 6M0 6c0 .365.287.652.652.652h5.713c.261.757.992 1.305 1.852 1.305.861 0 1.566-.548 1.853-1.305h1.278A.646.646 0 0 0 12 6a.646.646 0 0 0-.652-.652H10.07a1.955 1.955 0 0 0-1.853-1.305c-.86 0-1.565.548-1.852 1.305H.652A.646.646 0 0 0 0 6m3.783-3.391a.646.646 0 0 1-.653-.652c0-.366.287-.653.653-.653.365 0 .652.287.652.653a.646.646 0 0 1-.652.652m7.565-1.305H5.635A1.955 1.955 0 0 0 3.783 0C2.922 0 2.217.548 1.93 1.304H.652A.646.646 0 0 0 0 1.957c0 .365.287.652.652.652H1.93c.261.756.992 1.304 1.853 1.304.86 0 1.565-.548 1.852-1.304h5.713A.646.646 0 0 0 12 1.957a.646.646 0 0 0-.652-.653"
      />
    </svg>
  );
}

export function Printer(props) {
  const fill = props.fill || 'black';
  const size = props.size || '24px';

  return (
    <svg width={size} height={getHeight(size, 16, 16)} viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(3.735 10.19)">
          <path
            fill={fill}
            d="M.248 2.04v3.055h7.971V0H.248v2.04zm.997 0h5.977V1.02H1.245v1.02zm0 2.035h5.977v-1.02H1.245v1.02z"
          />
        </g>
        <path fill={fill} d="M11.954 3.054V0H3.983v5.095h7.971z" />
        <path
          fill={fill}
          d="M13.942 3.054h-.997v3.061h-9.96v-3.06h-.99C.996 3.054 0 4.074 0 5.094v5.095c0 1.02.997 2.04 1.994 2.04h.991V9.17h9.96v3.06h.997c.997 0 1.995-1.02 1.995-2.04V5.095c0-1.02-.998-2.04-1.995-2.04z"
        />
      </g>
    </svg>
  );
}

export function Envelope(props) {
  const fill = props.fill || 'black';
  const size = props.size || '24px';

  return (
    <svg width={size} height={getHeight(size, 20, 16)} viewBox="0 0 20 16">
      <g fill="none" fillRule="evenodd" transform="translate(0 1)">
        <rect width="18" height="11" x="1" fill={fill} rx="1" />
        <path stroke="#FFF" d="M19.14.084L10.078 6 .963.084" />
      </g>
    </svg>
  );
}

export function Cross(props) {
  const fill = props.fill || 'black';
  const size = props.size || '24px';

  return (
    <svg width={size} height={getHeight(size, 24.8, 25.8)} viewBox="0 0 24.8 24.8">
      <path fill={fill} d="M.03 1.58L1.58.03l23.27 23.26-1.56 1.55z" />
      <path fill={fill} d="M23.22.03l1.55 1.55L1.51 24.85l-1.56-1.56z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons.js